import { render, staticRenderFns } from "./IQAnswerEntityRow.vue?vue&type=template&id=ddafc3aa&scoped=true"
import script from "./IQAnswerEntityRow.vue?vue&type=script&setup=true&lang=js"
export * from "./IQAnswerEntityRow.vue?vue&type=script&setup=true&lang=js"
import style0 from "./IQAnswerEntityRow.vue?vue&type=style&index=0&id=ddafc3aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddafc3aa",
  null
  
)

export default component.exports